import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { mountMfe } from '@schwab/mfe-registry/mount';
import { CoreService, IMfeProps } from '@charlesschwab/sac-ui-core';
import { APP_SETTINGS } from '@charlesschwab/as-ui-core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements, applyPolyfills } from '@schwab/web-components/dist/loader';
import { APP_CONTEXT } from './app/shared/types/sac-aip.intent.type';

import { LicenseManager, ModuleRegistry, AllEnterpriseModule, ValidationModule } from 'ag-grid-enterprise';

ModuleRegistry.registerModules([AllEnterpriseModule, ValidationModule]);
const agGridLicenseKey: string = (window as any)?.thirdParty?.agGridKey;
if (agGridLicenseKey) {
  LicenseManager.setLicenseKey(atob(agGridLicenseKey));
  console.log('ag-grid key set from window');
} else {
  LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-062235}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{The_Charles_Schwab_Corporation}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{SAC}_only_for_{140}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{SAC}_need_to_be_licensed___{SAC}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_July_2025}____[v3]_[01]_MTc1MzEzODgwMDAwMA==5bc23ceb2fa60284cb8210248d9a10a2'
  );
  console.log('ag-grid key set');
}

applyPolyfills().then(() => {
  defineCustomElements(window);
});

if (environment.production) {
  enableProdMode();
}

mountMfe('mutual-fund-investing-app-root', (props: IMfeProps) => {
  let providers = [];
  if (props) {
    providers = [
      { provide: CoreService, useValue: props.coreService },
      { provide: APP_SETTINGS, useValue: props.appSettings },
      { provide: APP_CONTEXT, useValue: props.additionalProps }
    ];
  } else {
    providers.push({ provide: APP_SETTINGS, useValue: { bffGatewayUrl: '/sac-aip-xl/' } });
  }

  if ((window as any).ngZone) {
    return platformBrowserDynamic(providers).bootstrapModule(AppModule, { ngZone: (window as any).ngZone });
  } else {
    return platformBrowserDynamic(providers).bootstrapModule(AppModule);
  }
});
